// Compatible with the existing verified success-page GTM/Meta/Pinterest dispatcher.
// This only stages a payload: a wallet click/authorization is never a purchase.
export function stageExpressPurchase(
  result,
  consent,
  storage,
  now = Date.now()
) {
  const ecommerce = result.quote?.ecommerce;
  if (!ecommerce || !result.orderId)
    throw new Error("Missing order tracking context.");
  const params = new URL(result.returnUrl).searchParams;
  const orderNumber = params.get("order_number") || "";
  const orderId = String(result.orderId);
  const purchase = { ...ecommerce, transaction_id: orderNumber || orderId };
  try {
    storage.setItem("order_id", orderId);
    if (orderNumber) storage.setItem("order_number", orderNumber);
    if (!consent.analytics && !consent.marketing) {
      storage.removeItem("vf_pending_purchase");
      return;
    }
    storage.setItem(
      "vf_pending_purchase",
      JSON.stringify({
        orderId,
        orderNumber,
        ts: now,
        ga4: consent.analytics
          ? { event: "purchase", ecommerce: purchase }
          : null,
        pinterest: consent.marketing ? purchase : null,
        fbq: consent.marketing
          ? {
              content_ids: ecommerce.items.map((item) => item.item_id),
              content_name: ecommerce.items.map((item) => item.item_name),
              content_type: "product",
              value: result.quote.amount / 100,
              currency: ecommerce.currency,
            }
          : null,
      })
    );
  } catch {
    /* Storage restrictions cannot interrupt a payment. */
  }
}
